export const getAOILayer = (aoi, site, style) => ({
	id: String(site?.id),
	type: 'fill',
	data: {
		type: 'geojson',
		data: {
			type: 'FeatureCollection',
			features: [
				{
					type: 'Feature',
					properties: {
						id: site?.id,
						name: site?.name,
						commodity: site?.commodity_id
					},
					geometry: aoi
				}
			]
		}
	},
	paint: {
		'fill-opacity': style?.fillOpacity || 0.2,
		'fill-outline-color': style?.outlineColor || 'black',
		'fill-color': style?.fillColor || 'black'
	}
});
